import { Badge, BadgeTone } from "@/components/ui/badge";

// Maps backend status strings to a consistent badge tone.
const toneByStatus: Record<string, BadgeTone> = {
  // hourly cycles
  ok: "good",
  running: "info",
  error: "bad",
  paused: "warn",
  // pending approvals
  pending: "warn",
  approved: "good",
  rejected: "bad",
  executed: "good",
  failed: "bad",
  // scalp positions
  open: "info",
  closed_target: "good",
  closed_trailing: "good",
  closed_breakeven: "warn",
  closed_stop: "bad",
  closed_timeout: "muted",
  // hourly auto-exit positions
  closed_by_llm: "info",
  closed_manual: "muted",
  // scalp tick
  disabled: "muted",
  busy: "warn",
  stop_file: "bad",
  loss_cooldown: "warn",
};

export function StatusPill({ status }: { status: string | null | undefined }) {
  if (!status) return <span className="text-muted text-xs">-</span>;
  const tone = toneByStatus[status] ?? "default";
  return <Badge tone={tone}>{status.replace(/_/g, " ")}</Badge>;
}
